import { Divider } from 'antd';
import { ReactNode } from 'react';

export interface ProfileMenuItem {
	key: string;
	label: string;
	icon: ReactNode;
	onClick: () => void;
	variant?: 'default' | 'danger';
	visible?: boolean;
}

interface ProfileMenuProps {
	items: ProfileMenuItem[];
}

export const ProfileMenu = ({ items }: ProfileMenuProps) => {
	const visibleItems = items.filter((item) => item.visible !== false);

	return (
		<div className="bg-white border border-gray-200 rounded-lg shadow-md p-1">
			{visibleItems.map((item, index) => (
				<div key={item.key}>
					<div
						onClick={item.onClick}
						className={`flex items-center gap-x-2 px-3 py-2 cursor-pointer rounded-md
							${item.variant === 'danger' ? 'hover:bg-red-50' : 'hover:bg-gray-100'}
						`}
					>
						{item.icon}
						<span
							className={`font-sans font-medium text-sm
								${item.variant === 'danger' ? 'text-red' : 'text-gray-700'}
							`}
						>
							{item.label}
						</span>
					</div>

					{index < visibleItems.length - 1 && <Divider className="my-1" />}
				</div>
			))}
		</div>
	);
};
